'use strict';

function Header() {
    /********************************/
    // init header
    /********************************/
    this.initHeader = function () {
        $('#header-search-trigger').click(function(){
            var search = $('#header-search');
            var form = $('#header-search form');
            var input = $('#header-search form input[type=text]');
            var trigger = $('#header-search-trigger');
            var logo = $('#header-logo');

            trigger.hide();

            logo.css({
                'opacity' : 0.1
            });

            search.css({
                'position': 'absolute',
                'width': '100%'
            });

            form.show();
            input.focus();
            return false;
        });

        $('#header-search-close').click(function(){
            var search = $('#header-search');
            var form = $('#header-search form');
            var trigger = $('#header-search-trigger');
            var logo = $('#header-logo');

            form.hide();

            search.css({
                'position': 'relative',
                'width': ''
            });

            trigger.show();

            logo.css({
                'opacity' : 1
            });
            return false;
        });

    };
}
